import { render, staticRenderFns } from "./atendimento-popup.vue?vue&type=template&id=16da9116&scoped=true&"
import script from "./atendimento-popup.vue?vue&type=script&lang=js&"
export * from "./atendimento-popup.vue?vue&type=script&lang=js&"
import style0 from "./atendimento-popup.vue?vue&type=style&index=0&id=16da9116&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da9116",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VProgressCircular,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16da9116')) {
      api.createRecord('16da9116', component.options)
    } else {
      api.reload('16da9116', component.options)
    }
    module.hot.accept("./atendimento-popup.vue?vue&type=template&id=16da9116&scoped=true&", function () {
      api.rerender('16da9116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/atendimento-popup/atendimento-popup.vue"
export default component.exports